import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { useCommunityInboxStore } from "@circle-react/hooks/chatsV2/store";
import { useNavigate } from "@tanstack/react-router";

import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";

import { useCommunityAiAgentProfileContext } from "../context";

export const Sidebar = () => {
  const { isLoading, agent } = useCommunityAiAgentProfileContext();
  const { can_interact: canInteract } = agent;
  const navigate = useNavigate();
  const { setCurrentBotProfile } = useCommunityInboxStore();
  const handleNewChat = () => {
    setCurrentBotProfile(agent.profile);
    void navigate({
      to: "/messages/$uuid",
      params: { uuid: "new" },
    });
  };

  if (isLoading) return null;

  return (
    <div className="border-primary bg-primary dark:bg-primary col-span-full flex flex-col items-center overflow-auto border-r bg-[linear-gradient(180deg,#F5ECFC_19.48%,#FFF_50%)] px-6 pb-10 pt-8 md:col-span-4 dark:bg-none">
      <img
        loading="eager"
        src={agent.avatar_url}
        alt={agent.name}
        className="size-[152px] rounded-full"
      />
      <div className="mt-6 flex w-full flex-col items-center gap-[28px] text-center">
        <div className="flex flex-col items-center gap-4">
          <Typography.LabelLg weight="semibold" color="text-dark">
            {agent.name}
          </Typography.LabelLg>
          <div className="bg-tertiary dark:bg-secondary-dark flex h-6 items-center justify-center gap-1.5 rounded-full px-2 py-[3px]">
            <Icon type="16-ask-ai-gradient" size={16} />
            <span className="text-dark text-[12px] font-medium">
              {t("community_bot.profile_tag")}
            </span>
          </div>
        </div>
        {canInteract && (
          <div className="w-full">
            <Button variant="circle" onClick={handleNewChat}>
              {t("community_inbox.new_conversation")}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
